import { Box, Button, HStack, Text } from '@chakra-ui/react'
import { Gallery, Spotlight } from '@components/icons'
import { useParticipantIds } from '@daily-co/daily-react'
import React from 'react'
import {
  DialogBody,
  DialogContainer,
  DialogHeader
} from '../../../components/dialog'
import { useActiveTelehealthSession } from '../context/active-telehealth-session.context'

export const LayoutSettingsModal = ({
  isOpen,
  onClose
}: {
  isOpen: boolean
  onClose: () => void
}) => {
  const { setLayout, currentLayout, setIsLayoutSettingsModalOpen } =
    useActiveTelehealthSession()
  const participantIds = useParticipantIds()

  const handleLayoutChange = (value: string) => {
    setLayout({
      name: value as 'spotlight' | 'gallery',
      isUserSet: true
    })
    setIsLayoutSettingsModalOpen(false)
  }

  return (
    <DialogContainer scrollBehavior="inside" isOpen={isOpen} onClose={onClose}>
      <DialogHeader text="Change layout" onClose={onClose} />
      <DialogBody>
        <HStack>
          <Button
            borderColor={
              currentLayout.name === 'spotlight' ? 'primary' : 'pale_gray'
            }
            height="auto"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            variant="outline"
            py="small"
            px="medium"
            onClick={() => handleLayoutChange('spotlight')}
            borderRadius="8px"
            data-click-text="Spotlight layout"
          >
            <Box>
              <Spotlight />
            </Box>
            <Text w="80px" mt="xsmall" textAlign="center">
              Spotlight
            </Text>
          </Button>
          <Button
            borderColor={
              currentLayout.name === 'gallery' ? 'primary' : 'pale_gray'
            }
            isDisabled={participantIds.length === 1}
            height="auto"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            variant="outline"
            py="small"
            px="medium"
            onClick={() => handleLayoutChange('gallery')}
            borderRadius="8px"
            data-click-text="Gallery layout"
          >
            <Box>
              <Gallery />
            </Box>
            <Text w="80px" mt="xsmall" textAlign="center">
              Gallery
            </Text>
          </Button>
        </HStack>
      </DialogBody>
    </DialogContainer>
  )
}
